import * as React from "react";
import TerminalTable from "../components/TerminalTable"
import "../App.css";


export default function Terminal() {

  return (
    <TerminalTable/>
  );
}
